import TranslationNS from '@/utils/Constants/TranslationNS'

const COMMUNICATION = TranslationNS.COMMUNICATION

/**
 * Emailing › « Historique des e-mails » (`emailing/history`): the counts, the history card, its
 * audience chips, search and count, the table (and the drawer a row opens), the pager, the link to
 * the send page.
 */
export const EMAIL_HISTORY_TOUR = {
    id: 'email-history',
    version: 1,
    paths: ['emailing/history'],
    steps: [
        {
            key: 'head',
            target: '[data-tour="page-head"]',
            placement: 'bottom',
            title: 'Your sent e-mails',
            description: 'How many e-mails were sent and when the last one went out.',
        },
        {
            key: 'list',
            // the card's title band, not the card: a list taller than the screen leaves no room for the bubble
            target: '[data-tour="sec-history"]',
            block: ':scope > .org-sec-h',
            placement: 'bottom',
            title: 'The list of e-mails',
            description: 'Every e-mail sent from this event, newest first.',
        },
        {
            key: 'filters',
            target: '[data-tour="hist-filters"]',
            placement: 'bottom',
            title: 'Filter by audience',
            description: 'These buttons show only the e-mails sent to athletes, volunteers or spectators.',
        },
        {
            key: 'search',
            target: '[data-tour="hist-search"]',
            placement: 'bottom',
            title: 'Search an e-mail',
            description:
                'Type a name or an address to find an e-mail. « Reset filters » clears everything; the count on the right tells how many match.',
        },
        {
            key: 'table',
            target: '[data-tour="sec-history"] .org-tbl',
            block: 'thead',
            placement: 'bottom',
            title: 'Open an e-mail',
            description:
                'Each row: date, audience, number of recipients, state. Click a row to open it; the arrows move to the previous or next e-mail.',
            entries: [
                { label: 'Sent', ns: COMMUNICATION, text: 'the e-mail has gone out.' },
                { label: 'Scheduled', ns: COMMUNICATION, text: 'it is queued and leaves shortly.' },
                {
                    label: 'Recipients',
                    ns: COMMUNICATION,
                    text: 'who received it, with the invalid addresses skipped.',
                },
                { label: 'Content', ns: COMMUNICATION, text: 'the message exactly as sent.' },
            ],
        },
        {
            key: 'pager',
            target: '[data-tour="sec-history"] .org-pager',
            placement: 'top',
            title: 'Page by page',
            description: 'Choose how many rows per page and move between pages.',
        },
        {
            key: 'send',
            target: '[data-tour="hist-send"]',
            placement: 'bottom',
            placementNarrow: 'top',
            title: 'Write a new e-mail',
            description: 'This button opens the send page.',
        },
    ],
}

export default EMAIL_HISTORY_TOUR
